export const MUSIC_DRAFT_STORAGE_KEY = 'music-generator-form'
export const COVER_DRAFT_STORAGE_KEY = 'cover-generator-form'
export const TTS_DRAFT_STORAGE_KEY = 'tts-generator-form'
export const RAP_DRAFT_STORAGE_KEY = 'rap-generator-form'

/** 所有草稿缓存 key，signOut 时统一清除，新增 key 务必加入此数组 */
export const ALL_DRAFT_STORAGE_KEYS = [
  MUSIC_DRAFT_STORAGE_KEY,
  COVER_DRAFT_STORAGE_KEY,
  TTS_DRAFT_STORAGE_KEY,
  RAP_DRAFT_STORAGE_KEY,
] as const
